import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {MachineGroupComponent} from '@components/administration/machine-group/machine-group.component';
import {MachineGroupConfigurationComponent} from '@components/administration/machine-group/machine-group-configuration/machine-group-configuration.component';
import {AuthorizationGuardService} from '../../../shared/authorization-guard/authorization-guard.service';


const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'machinegroups', component: MachineGroupComponent, canActivate: [AuthorizationGuardService]},
  {path: 'machinegroups/:details', component: MachineGroupConfigurationComponent, canActivate: [AuthorizationGuardService]},
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class MachineGroupRoutingModule {
}
